import { CTAEditor } from '/src/features/addons/ctas/editor/CTAEditor';

// eslint-disable-next-line no-restricted-syntax
export default function NewCTATemplate() {
  return <CTAEditor isTemplate={true} />;
}
